// Common query page sizes to be consistent
export enum PageSize {
  All = 1000,
}
